/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index';

let exports = {};
//
exports.getContextWatermark = function (params, callback) {
    api.get('/comn/ctx/watermark')
        .params(params)
        .done(callback)
        .fail(callback)
        .go()
};
//
exports.getSysEnvName = function (params, callback) {   // 获取当前/指定系统环境名称
    api.get('/comn/sys/envName/get')
        .params(params)
        .done(callback)
        .go()
};

// 费用分摊或误差平衡
exports.calcFeeShareResult = function (shareModel, aspect /* calc 分摊计算， balns 误差平衡，both 分摊计算 + 误差平衡 */, callback) {
    api.post('/comn/fee/share/result/calc')
        .params({
            aspect: aspect || null
        })
        .data(shareModel)
        .done(callback)
        .go()
};


//刷新授权登陆码"
exports.renewGrantLoginCode = function (callback) {
    api.post('/grant/login/code/renew')
        .done(callback)
        .go();
};
//获取授权登陆信息
exports.getGrantLoginInfo = function (params, callback) {
    api.get('/grant/login/info/get')
        .params(params)
        .done(callback)
        .go();
};
// 执行被授权后的登陆
exports.doGrantLoginAfterGranted = function (params, callback) {
    api.post('/grant/login/do/after/granted')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};

exports.getRegionListByIds = function (data, callback) {// 根据ids获取地区列表
    api.post('/comn/region/list/get/by/ids')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

//
exports.getRegionListByParentId = function (data, callback) {// 根据父id获取地区列表
    api.post('/comn/region/list/get/by/parentId')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

//查询银行信息
exports.getBankList = function (callback) {// 获取银行列表
    api.get('/comn/bank/list/get')
        .done(callback)
        .go();
};

//查询物流公司
exports.getLogisComPagedList = function (data, callback) {// 获取物流公司分页列表
    api.post('/comn/com/paged/list/get')
        .data(data)
        .done(callback)
        .go();
};

exports.getColorList = function (params, callback) {// 分页颜色信息
    api.post('/comn/color/list/get')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

//查询行业类型
exports.getIndustryTypeList = function (params, callback) {// 获取行业类型列表
    api.post('/comn/industry/type/list/get')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

// 获取文件的变更记录
exports.getFileBizRecListByUuid = function (params, callback) {
    api.get('/comn/file/biz/rec/list/by/uuid')
        .params(params)
        .done(callback)
        .go()
};

// =================================== 查询发送的站内信列表 ===============================
//获取消息（按自定义字段，不分页）
exports.getSendMsgList = function (params, callback) {
    api.post('/comn/xmsg/list/fetch')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};


//历史记录查询
exports.queryHisRecords = function (requestData /* PaginatedQry */, callback) {
    api.post('/comn/his/records/query')
        .data(requestData)
        .done(callback)
        .fail(callback)
        .go();
};

//获取外部资源对应的页面url
exports.getOuterOpenPageUrl = function (outerRescId, callback) {
    api.post('/comn/outer/open/page/url')
        .params({
            outerRescId: outerRescId || null
        })
        .done(callback)
        .fail(callback)
        .go();
};

//------------------手机App（固定）角色----------------------

//【手机App（固定）角色】分页列表
exports.getMobAppRoleList = function (data, callback) {
    api.post('/comn/mob/role/list')
        .data(data)
        .done(callback)
        .go()
};

exports.getSysDomianName = function (callback) {
    api.get('/comn/sys/domain/name/get')
        .done(callback)
        .go()
};

//【手机App（固定）角色】关联资源-获取角色适用资源
exports.getMobAppRoleRescListByCode = function (params, callback) {
    api.get('/comn/mob/role/resc/list/by/code/get')
        .params(params)
        .done(callback)
        .go()
};

// 根据code获取公开协议
exports.getOperatorPubAgreement = function (params, callback) {
    api.get('/comn/operator/pub/greement/get/by/code')
        .params(params)
        .done(callback)
        .go()
};

// ======== 服务商业务日志 ===========

exports.saveServicerBizLog = function (data, callback) {   // 左边菜单栏 点击记录的 操作日志
    api.post('/servicer/biz/log/save/do')
        .data(data)
        .done(callback)
        .go()
};

// 获取用户资质列表
exports.getUserQualiListByFilter = function (data, callback) {
    api.post('/comn/user/quali/list/get')
        .data(data)
        .done(callback)
        .go()
};
// 获取用户资质
exports.getUserQualiById = function (data, callback) {
    api.get('/comn/user/quali/info/get')
        .params(data)
        .done(callback)
        .go()
};
// 获取用户资质ids
exports.getUserQualiIds = function (data, callback) {
    api.post('/comn/user/quali/ids/get')
        .data(data)
        .done(callback)
        .go()
};
// 获取用户资质列表
exports.getUserQualisByFilter = function (data, callback) {
    api.post('/comn/user/qualis/get')
        .data(data)
        .done(callback)
        .go()
};
//
exports.getHelpArticleByCode = function (data, callback) {// 获取帮助文章
    api.post('/help/article/get/by/code')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
//
exports.getUserManualInfo = function (params, callback) {// 获取用户手册
    api.get('/comn/user/manual/info/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};

// 获取下次执行时间
exports.getNextExecutionTime = function (data, callback) {
    api.post('/comn/next/execut/time/get')
        .data(data)
        .done(callback)
        .go()
};

// ==================== 批量下载任务 ==================
exports.getAsynTaskInfoList = function (data, callback) {
    api.post('/comn/asyn/task/info/list')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getAsynTaskInfoByUk = function (data, callback) {
    api.post('/comn/asyn/task/info/uk/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.saveAsynTaskInfo = function (data, callback) {
    api.post('/comn/asyn/task/info/save')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.doAsynTaskInfoCancelled = function (data, callback) {
    api.post('/comn/asyn/task/info/cancelled/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.deleteAsynTaskInfo = function (data, callback) {
    api.post('/comn/asyn/task/info/delete/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

//品牌
exports.getBrandPagedList = function (data, callback) {// 获取品牌分页列表
    api.post('/comn/brand/paged/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 获取通用操作记录接口
exports.getXxxActRecsByFilter = function (data, callback) {
    api.post('/comn/xxx/act/rec/list')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/comn.js
// module id = 18
// module chunks = 1